module.exports = "/images/xk.svg?094ee51c2356c26398205f664b43586c";